import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React, { useEffect } from 'react';
import { tableFromIPC } from 'apache-arrow';
import { AnimatePresence, motion } from 'framer-motion';
import { SourceSkeleton, useParcaContext, useURLState } from '@parca/components';
import { ExpandOnHover } from '../GraphTooltipArrow/ExpandOnHoverValue';
import { truncateStringReverse } from '../utils';
import { Highlighter, profileAwareRenderer } from './Highlighter';
export const SourceView = React.memo(function SourceView({ data, loading, total, filtered, setActionButtons, }) {
    const [sourceFileName] = useURLState({ param: 'source_filename', navigateTo: () => { } });
    const { isDarkMode } = useParcaContext();
    useEffect(() => {
        setActionButtons?.(_jsx("div", { className: "px-2", children: _jsx(ExpandOnHover, { value: sourceFileName, displayValue: truncateStringReverse(sourceFileName, 50) }) }));
    }, [sourceFileName, setActionButtons]);
    if (loading) {
        return (_jsx("div", { className: "h-auto overflow-clip", children: _jsx(SourceSkeleton, { isDarkMode: isDarkMode }) }));
    }
    if (data === undefined) {
        return _jsx(_Fragment, { children: "Source code not uploaded for this build." });
    }
    const table = tableFromIPC(data.record);
    const cumulative = table.getChild('cumulative');
    const flat = table.getChild('flat');
    return (_jsx(AnimatePresence, { children: _jsx(motion.div, { className: "h-full w-full", initial: { display: 'none', opacity: 0 }, animate: { display: 'block', opacity: 1 }, transition: { duration: 0.5 }, children: _jsx(Highlighter, { file: sourceFileName, content: data.source, renderer: profileAwareRenderer(cumulative, flat, total, filtered) }) }, "source-view-loaded") }));
});
export default SourceView;
